import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/auth.context";
import styles from './style.module.scss';
import ModalWindow from "../../../shared/ModalWindow";
import SupportModal from "../../../shared/SupportModal";
import ConfirmDocs from "../ConfirmDocs";
import { t } from "i18next";

const ProfilePassword = ({user,onOpenModal, closeModal, isModalOpen, changePassword, changeDisplay, changeModeration}) => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const handleLogout = event => {
    event.preventDefault()
    event.stopPropagation()
    logout();
    navigate("/login", { replace: true });
  };
    return (
      <div className={styles['profile__password']}>
        <div className={styles['profile__password-title']}>{t("settings.title")}</div>
        <hr className={styles['profile__password-hr']}/>
        <div className={styles['profile__password-subtitle']} onClick={changePassword}>{t("settings.changePassword")}</div>
        {/* <button className={styles['profile__password-subtitle']} onClick={onOpenModal}>{t("settings.uploadDocuments")}</button> */}
        {isModalOpen && (
          <ModalWindow
            contentFull
            bgTransparent={false}
            onClose={closeModal}
            footerSlot={<SupportModal />}
          >
            <ConfirmDocs
              userId={user?.id}
              updateData={() => {
                changeModeration(true);
                changeDisplay(false);
              }}
              onClose={closeModal}
              isDisplayModal={isModalOpen}
            />
          </ModalWindow>
        )}
        <button className={styles['profile__password-subtitle']} onClick={handleLogout}>{t("settings.logout")}</button>
      </div>
    );
};

export default ProfilePassword;
